import { render, staticRenderFns } from "./LocationModalFooter.vue?vue&type=template&id=380504dc&"
import script from "./LocationModalFooter.vue?vue&type=script&lang=js&"
export * from "./LocationModalFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports